import "./Banner.css";
import React, {useContext, useMemo} from "react";
import ClienteDirectoContext from "../../../context/ClienteDirectoContext";
import Companies from "../Companies";
import {getActiveCompanyNames} from "../../../utils/resolveActiveCompanies";

const Banner = () => {
    const {activeProducts, companiesIdDict} = useContext(ClienteDirectoContext);

    const companiesName = useMemo(
        () => getActiveCompanyNames(activeProducts, companiesIdDict),
        [activeProducts, companiesIdDict]
    );

    return (
        <section className="Landing__hero Landing__gradientMotion">
            <p className="Landing__heroEyebrow">Tu seguro digital</p>
            <h1 className="Landing__heroTitle">
                Contratá tu seguro
                <br/>
                <strong>fácil, rápido y 100% online</strong>
            </h1>
            <p className="Landing__heroSubtitle">
                Cotizá y comprá en minutos, con acompañamiento de tu productor de confianza
            </p>
            <Companies activeCompanies={companiesName} variant="hero"/>
        </section>
    );
};

export default Banner;
